<script>
  import { layoutMethods, billsPaymentMethods, exportMethods,erpFixMessages, mopMethods, mopComputed } from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Swal from 'sweetalert2';
  import moment from 'moment-timezone';
  /**
   * Bills Payment Topup List component
   */
  export default {
    page: {
      title: "Bills Payment Topup List"
    },
    components: {
      flatPickr
    },
    computed: {
      ...erpFixMessages,
      ...mopComputed,
    },
    data() {
      return {
        title: "Transaction Logs",
        searchValue: {
          searchField: null,
          search: "",
          dateRange: null,
          sort: 'id',
          orderDesc: true,
          status: null,
          page: 1,
          rows: 10,
          payment_mode: null
        },
        searchOptions: [
          { text: 'Search All', value: null },
          { text: 'Customer Name', value: "name" },
          { text: 'Transaction ID', value: "trans_reference_no" }
        ],
        statusList: [
          { text: 'All', value: null },
          { text: 'Processing', value: "pending" }, // change label PEDDLR-2100
          { text: 'Failed', value: "failed" },
          { text: 'Success', value: "success" },
        ],
        rangeOptions: {
          mode: "range",
        },
        sortBy: "value",
        sortDesc: false,
        fields: [
          { key: "trans_reference_no", label: "Transaction ID", sortable: true},
          { key: "name", label: "Customer Name", sortable: true},
          { key: "status", label: "Status", sortable: true},
          { key: "wallet", label: "Wallet", sortable: true},
          { key: "payment_mode", label: "Payment Method", sortable: true},
          { key: "service_fee", label: "Service Fee", sortable: true},
          { key: "trans_amount", label: "Amount", sortable: true},
          { key: "total_amount_paid", label: "Total Amount Paid", sortable: false},
          { key: "trans_datetime", label: "Date", sortable: true}
        ],
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        tableList: [],
        tableCount:0,
        paymentOptions: [
          { text: "All", value: null },
        ],
      };
    },
    methods: {
      ...layoutMethods,
      ...billsPaymentMethods,
      ...exportMethods,
      ...mopMethods,
      async onExport(){
        await this.onSearch("reset");
        if(this.tableCount ==0){
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }
        // var search_value_holder = this.searchValue;
        let params = Object.assign(
          // this.searchValue,
          {
            module: 'bills_payment_topup_logs',
            email: JSON.parse(localStorage.getItem('userData')).email,
            dateRange: this.searchValue.dateRange,
            orderDesc: this.searchValue.orderDesc,
            search: this.searchValue.search,
            searchField: this.searchValue.searchField,
            sort: this.searchValue.sort,
            payment_mode: this.searchValue.payment_mode,
            status: this.searchValue.status
          });
        
        this.exportReport(params)
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
          console.log("value:",this.searchValue,params)
      },
      async onSearch(state){
        if(state == 'reset'){
          this.searchValue.page = 1;
        }
        // console.log(":: search ::", this.searchValue);
        // alert("hey");
        await this.actionBillsPayment({
            action: "topup-report",
            body: this.searchValue
        })
        .then((res) => {
          console.log(res);
          this.tableList = res["message"]["rows"];
          this.tableCount = res["message"]["pageInfo"]["total"];
        }).catch((e)=>{
          console.log("error while getting bills payment list",e);
        });
      },
      tableSort(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        console.log(">> sorting",this.searchValue);
        this.onSearch('reset');
      },
      onDisplayChange(){
        if(
          (this.tableList.length < this.tableCount && this.tableList.length != this.searchValue.rows) || // condition for incrementing display per page
          (this.tableList.length == this.tableCount && this.searchValue.rows < this.tableList.length) // condition for decreasing display per page
          ){
          this.searchValue.page=1;
          this.onSearch('reset')
        }
      },
      getPaymentMethods(){
        this.listAllMop()
          .then(() => {
            this.mops.bills_pay.forEach(mop => {
              let mopName = mop.name == 'PayMaya' ? 'Maya' : mop.name;
              let existing = this.paymentOptions.some(p => p.text == mopName && p.value == mopName);
              if (!existing) {
                this.paymentOptions.push({
                  text: mopName,
                  value: mopName,
                })
              }
            })
          })
      }
    },
    async mounted(){
      this.changeTitle({title: 'Transaction Logs'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Report', to: { name: 'Bills Payment Topup'} },
          { text: 'Bills Payment Topup', to: { name: 'Bills Payment Topup'} }
        ]
      });
      var date_today = moment().format('YYYY-MM-DD');
      var date_range = date_today + ' to ' + date_today;
      this.searchValue.dateRange = date_range
      this.onSearch('reset');
      this.getPaymentMethods();
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-4 col-sm-4">
                            <div class="my-2">
                                <h5 class="card-title text-dark">
                                    <span class="fw-normal ms-lg-2"> {{ tableCount }} </span> Record(s)
                                </h5>
                            </div>
                        </div>
                        <!-- end col record display--> 
                        <div class="col-md-8 col-sm-8">
                            <div class="d-flex justify-content-lg-end mb-lg-3">
                                <a class="btn btn-secondary" @click="onSearch()"
                                    ><feather
                                    type="refresh-ccw"
                                    size="16"
                                    class="icon nav-icon"
                                    ></feather
                                    >&nbsp;&nbsp; Refresh</a
                                >
                            </div>
                        </div>
                        <!--end of header buttons-->
                        <div class="row">
                          <div class="w-auto mb-2">
                            <div class="d-flex mt-3 mb-3">
                              <div class="me-3">
                                <form class="d-flex" @submit.prevent="onSearch('reset')">
                                  <b-form-group id="input-group-3" label-for="input-3">
                                    <b-form-select class="form-select rounded-0 rounded-start shadow-none w-200px" id="input-3" v-model="searchValue.searchField" :options="searchOptions"></b-form-select>
                                  </b-form-group>
                                  <b-form-group id="input-group-3" class="text-align-right" label-for="input-3">
                                    <template v-slot:description><div class="d-flex justify-content-end">Search for keyword</div></template>
                                    <b-form-input id="input-keyword" v-model="searchValue.search" class="rounded-0" style="width: auto"></b-form-input>
                                  </b-form-group>
                                </form>
                              </div>
                              <div class="me-3 ta-right">
                                <b-form-group label-for="transaction-status" description="Filter by status">
                                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:120px"
                                    id="transaction-status"
                                    v-model="searchValue.status"
                                    :options="statusList"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                              <div class="me-3 ta-right">
                                <b-form-group label-for="transaction-payment-method" description="Filter by payment method">
                                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                                    id="transaction-payment-method"
                                    v-model="searchValue.payment_mode"
                                    :options="paymentOptions"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                              <div class="me-3 ta-right">
                                <b-form-group description="Filter by Request Date">
                                  <flat-pickr
                                    v-model="searchValue.dateRange"
                                    :config="rangeOptions"
                                    placeholder="Select a date range"
                                    class="form-control"
                                    style="width: fit-content"
                                  ></flat-pickr>
                                </b-form-group>
                              </div>
                              <div class="me-3">
                                  <b-button variant="primary" type="button" @click="onSearch('reset')" class="px-2 me-2">
                                    <i class='bx bx-search bx-fw'></i>
                                    Search
                                  </b-button>
                                  <a href="javascript:void(0);" class="btn btn-primary me-2" @click="onExport">
                                    <i class="uil uil-export me-1"></i>
                                    Export
                                  </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- end search div--> 
                    </div>
                    <!-- end row -->

                    <div class="table-responsive">
                      <div class="table align-middle table-nowrap">
                        <b-table
                          :items="tableList"
                          :fields="fields"
                          responsive="sm"
                          :current-page="searchValue.page"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          class="table-check"
                          @sort-changed="tableSort"
                        >
                            <template #cell(trans_reference_no)="data">
                              <router-link :to="{ name: 'Bills Payment Topup Details', params: { id: data.item.id, userId: data.item.user_id}}">
                                <span v-bind:title='data.item.trans_reference_no'>{{data.item.trans_reference_no | truncator(30,'...')}}</span>
                              </router-link>
                            </template>
                            <template #cell(trans_datetime)="data">
                              {{ data.item.trans_datetime | formatDate }}
                            </template>
                            <template #cell(status)="data">
                              <span class="text-uppercase"
                                :class="{
                                    'text-success': data.item.status == 'success',
                                    'text-danger': data.item.status == 'failed',
                                    'text-warning': data.item.status == 'pending',
                                }">
                                {{ (data.item.status == 'pending')? "processing":data.item.status}}
                              </span>
                            </template>
                            <template #cell(service_fee)="data">
                              <p class="text-body text-end m-0">
                                ₱ {{ data.item.service_fee.toFixed(2) }}
                              </p>
                            </template>
                            <template #cell(trans_amount)="data">
                              <p class="text-body text-end m-0">
                                ₱ {{ data.item.trans_amount.toFixed(2) }}
                              </p>
                            </template>
                            <template #cell(total_amount_paid)="data">
                              <p class="text-body text-end m-0">
                                ₱ {{ data.item.total_amount_paid.toFixed(2) }}
                              </p>
                            </template>
                        </b-table>
                      </div>
                    </div>
                    <!-- end table responsive -->
                    <div class="row g-0 text-center" v-if="tableCount == 0">
                      <span>No data to display.</span>
                    </div>
                    <div class="row g-0 text-center text-sm-start" v-if="tableCount != 0 && tableCount > 10">
                      <!-- end col -->
                      <div class="col-sm-12">
                        <div class="row">
                          <div class="col">
                            <div class="form-group row pull-left">
                              <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                              <div class="col-sm-6">
                                <b-form-group label-for="display-record">
                                  <b-form-select class="form-select shadow-none w-fit"
                                    id="display-record"
                                    v-model="searchValue.rows"
                                    :options="pageOptions"
                                    @change="onDisplayChange()"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                            </div>
                            <div
                              class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                              "
                            >
                              <!-- pagination -->
                              <b-pagination
                                class="pagination-rounded"
                                v-model="searchValue.page"
                                :total-rows="tableCount"
                                @input="onSearch()"
                                :per-page="searchValue.rows"
                              ></b-pagination>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- end col -->
                    </div>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>